import '../asset/css/grid-2.0.0.css'
import '../asset/css/nav.css'
import '../asset/css/pad-margin-2.0.0.css'
import '../asset/css/alignment.css'
import '../asset/css/tags-2.0.0.css'
import '../asset/css/box.css'
import '../asset/css/form-2.0.0.css'
import '../asset/css/select.css'
import '../asset/css/colors.css'
import '../asset/css/button.css'
import '../asset/css/styles-1.0.0.css'
import '../asset/css/table-2.0.2.css'
import '../asset/css/Modal.css'

import React from 'react';


function Hdr(){

  return(
    <></>
  )
}

export default Hdr;
